export class CountryParams {
    public forLegacy: boolean;
    public addressType: Number;
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/models/countryParams.ts